<!-- single-tree.component.html -->
<div class="single-tree-container"
     [class.bilingual-mode]="selectedLanguage === 'bilingual'"
     [class.hindi-only-mode]="selectedLanguage === 'hindionly'"
     [class.english-only-mode]="selectedLanguage === 'englishonly'">

    <!-- View/Settings Toolbar -->

    <mat-toolbar class="pane-header">
        <!-- Layout Switcher slot -->
        <div class="layout-switcher-container">
            <ng-content select="app-layout-switcher[hideSearch]"></ng-content>
        </div>

        <!-- Search functionality - REDESIGNED -->
        <div class="search-filter-container" [class.expanded]="isSearchExpanded">
            <div class="search-input-wrapper" [class.expanded]="isSearchExpanded">
                <button
                    mat-icon-button
                    class="search-toggle-button"
                    [class.active]="isSearchExpanded"
                    (click)="toggleSearch()"
                    matTooltip="Toggle Search">
                    <mat-icon>{{ isSearchExpanded ? 'search_off' : 'search' }}</mat-icon>
                </button>

                <div class="search-input-container" [class.expanded]="isSearchExpanded">
                    <input
                        #searchInput
                        class="search-input"
                        type="text"
                        placeholder="Search..."
                        [(ngModel)]="searchTerm"
                        (input)="onSearchInput()"
                    />
                    <button
                        *ngIf="searchTerm"
                        mat-icon-button
                        class="clear-search"
                        (click)="clearSearch()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>

                <div class="filter-toggle-container" *ngIf="isSearchExpanded">
                    <mat-slide-toggle
                        class="filter-toggle"
                        [checked]="filterMode"
                        (change)="toggleFilterMode($event)"
                        matTooltip="Filter Search">
                        Filter
                    </mat-slide-toggle>
                </div>
            </div>
        </div>

        <!-- Horizontal View Toggle Button (moved outside search wrapper) -->
        <button
            mat-icon-button
            class="horizontal-view-toggle"
            [class.active]="showHorizontalTabs"
            (click)="toggleHorizontalView()"
            matTooltip="{{ showHorizontalTabs ? 'Switch to Tree View' : 'Switch to Horizontal Tabs' }}">
            <mat-icon>{{ showHorizontalTabs ? 'view_sidebar' : 'view_stream' }}</mat-icon>
        </button>

        <div class="spacer"></div>

        <!-- Blog Mode Toggle Slider -->
        <div class="blog-mode-container">
            <mat-slide-toggle
                class="blog-mode-toggle"
                [checked]="blogMode"
                (change)="onBlogModeToggle($event)"
                matTooltip="Toggle Blog Mode">
                <span class="blog-mode-label">Blog Mode</span>
            </mat-slide-toggle>
        </div>

        <!-- Change Nav View Toggle Slider -->
        <div class="nav-view-container">
            <mat-slide-toggle
                class="nav-view-toggle"
                [checked]="changeNavView"
                (change)="onChangeNavViewToggle($event)"
                matTooltip="Toggle Floating Header Navigation">
                <span class="nav-view-label">Change Nav View</span>
            </mat-slide-toggle>
        </div>

        <!-- Language selector -->
        <div class="language-selector-container">
            <button mat-button class="language-selector-button" [matMenuTriggerFor]="languageMenu">
                <mat-icon>translate</mat-icon>
                <span class="language-label">{{ selectedLanguage === 'bilingual' ? 'Bilingual' : (selectedLanguage === 'englishonly' ? 'English' : 'Hindi') }}</span>
            </button>
            <mat-menu #languageMenu="matMenu" class="language-menu-panel">
                <button mat-menu-item *ngFor="let option of languageOptions"
                        (click)="onLanguageChange(option.value, $event)"
                        [class.selected]="selectedLanguage === option.value"
                        class="language-option">
                    {{ option.label }}
                </button>
            </mat-menu>
        </div>

        <!-- Action buttons container -->
        <div class="action-buttons-container">
            <button mat-icon-button
                    class="tree-action-button"
                    (click)="toggleAllNodes()"
                    matTooltip="{{ isTreeExpanded ? 'Collapse All' : 'Expand All' }}">
                <mat-icon>{{ isTreeExpanded ? 'unfold_less' : 'unfold_more' }}</mat-icon>
            </button>
        </div>
    </mat-toolbar>

    <!-- Horizontal Tabs View -->
    <div class="horizontal-tabs-container" *ngIf="showHorizontalTabs && p1Mode === 'topicwise'">
        <div class="tabs-wrapper">
            <div class="tabs-row">
                <div class="tab-item"
                     *ngFor="let subject of getSubjectsForTabs(); let i = index"
                     [class.active]="selectedSubject === subject.name"
                     [class.hovered]="hoveredTabIndex === i"
                     (mouseenter)="onTabMouseEnter(i)"
                     (mouseleave)="onTabMouseLeave()"
                     (click)="onTabItemClick(subject)">
                    <span class="tab-text" [innerHTML]="formatNodeName(subject.name, subject.nameHindi || hindiNameMap[subject.name] || subject.name)"></span>
                    <mat-icon class="dropdown-arrow" *ngIf="getSubjectChildren(subject).length > 0">arrow_drop_down</mat-icon>
                </div>
            </div>

            <!-- Dropdown Content -->
            <div class="dropdown-overlay" *ngIf="activeDropdownIndex !== null">
                <div class="dropdown-content"
                     (mouseenter)="onDropdownMouseEnter()"
                     (mouseleave)="onDropdownMouseLeave()">
                    <ng-container *ngFor="let subject of getSubjectsForTabs(); let i = index">
                        <div class="dropdown-panel" *ngIf="activeDropdownIndex === i">
                            <div class="dropdown-header">
                                <h4 [innerHTML]="formatNodeName(subject.name, subject.nameHindi || hindiNameMap[subject.name] || subject.name)"></h4>
                            </div>
                            <div class="dropdown-items">
                                <div class="dropdown-section" *ngFor="let child of getSubjectChildren(subject)">
                                    <div class="dropdown-item"
                                         [class.selected]="selectedNodePath.includes(child)"
                                         (click)="onTabItemClick(child)">
                                        <span [innerHTML]="formatNodeName(child.name, child.nameHindi || hindiNameMap[child.name] || child.name)"></span>
                                    </div>
                                    <!-- Show children of sections/topics -->
                                    <div class="dropdown-sub-items" *ngIf="child.children && child.children.length > 0">
                                        <div class="dropdown-sub-item"
                                             *ngFor="let subChild of child.children"
                                             [class.selected]="selectedNodePath.includes(subChild)"
                                             (click)="onTabItemClick(subChild)">
                                            <span [innerHTML]="formatNodeName(subChild.name, subChild.nameHindi || hindiNameMap[subChild.name] || subChild.name)"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div class="pane-content" [class.hidden]="showHorizontalTabs">
        <!-- TOPICWISE TREE -->
        <ng-container *ngIf="p1Mode === 'topicwise'">
            <div class="tree-container">
                <!-- Loading indicators -->
                <div *ngIf="isLoadingSubjects" class="loading-indicator">
                    <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
                    <span>Loading subjects...</span>
                </div>

                <div *ngIf="isLoadingSections" class="loading-indicator">
                    <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
                    <span>Loading sections...</span>
                </div>

                <div *ngIf="isLoadingTopics" class="loading-indicator">
                    <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
                    <span>Loading topics...</span>
                </div>

                <div *ngIf="isLoadingSubtopics" class="loading-indicator">
                    <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"></mat-progress-spinner>
                    <span>Loading subtopics...</span>
                </div>

              <div class="tree-actions-toolbar admin-toolbar" *ngIf="!isLoadingTopics">
                <button
                  mat-button
                  class="action-button"
                  (click)="showAllBundles()">
                  <mat-icon>list</mat-icon>
                  <span class="button-text">Show All Posts</span>
                </button>

                <button
                  mat-button
                  class="action-button"
                  (click)="refreshSubjects()">
                  <mat-icon>refresh</mat-icon>
                  <span class="button-text">Refresh subjects</span>
                </button>
              </div>

                <!-- Admin toolbar - only visible for internal users -->
                <div class="tree-actions-toolbar admin-toolbar" *ngIf="isInternalUser">
                </div>

                <!-- Tree view -->
                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="full-tree">
                    <!-- Leaf node template -->
                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="24"
                                  [class.selected]="selectedNodePath.includes(node)"
                                  [class.last-selected]="node === selectedNode">
                        <div class="node-content-container"
                            [class.selected]="selectedNodePath.includes(node)"
                            [class.last-selected]="node === selectedNode"
                            (click)="selectNode(node)">
                          <span class="node-content" [innerHTML]="formatNodeName(node.name, node.nameHindi || hindiNameMap[node.name] || node.name)"></span>
                        </div>
                    </mat-tree-node>

                    <!-- Parent node template -->
                    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild"
                                           [class.selected]="selectedNodePath.includes(node)"
                                           [class.last-selected]="node === selectedNode">
                        <div class="mat-tree-node"
                            [class.selected]="selectedNodePath.includes(node)"
                            [class.last-selected]="node === selectedNode"
                            (click)="selectNode(node)">
                            <!-- Node content container first -->
                            <div class="node-content-container"
                                 [class.selected]="selectedNodePath.includes(node)"
                                 [class.last-selected]="node === selectedNode">
                              <span class="node-content" [innerHTML]="formatNodeName(node.name, node.nameHindi || hindiNameMap[node.name] || node.name)"></span>
                            </div>

                            <!-- Toggle button moved to the right -->
                            <button mat-icon-button class="toggle-button" [attr.aria-label]="'Toggle ' + node.name"
                                    (click)="toggleNode($event, node)">
                                <mat-icon>{{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}</mat-icon>
                            </button>
                        </div>
                        <div [class.tree-invisible]="!treeControl.isExpanded(node)" role="group">
                            <ng-container matTreeNodeOutlet></ng-container>
                        </div>
                    </mat-nested-tree-node>
                </mat-tree>
            </div>
        </ng-container>

    </div>

    <!-- View/Settings Toolbar at the bottom -->
    <div class="view-settings-toolbar bottom-toolbar">
        <div class="toolbar-buttons">
            <!-- View button with font size options -->
            <button mat-button class="view-button" [matMenuTriggerFor]="viewMenu">
                <mat-icon>visibility</mat-icon>
                <span>View</span>
            </button>
            <mat-menu #viewMenu="matMenu" class="font-size-menu">
                <button mat-menu-item
                        *ngFor="let option of fontSizeOptions"
                        (click)="setFontSize(option.value)"
                        [class.selected]="currentFontSize === option.value">
                    {{ option.label }} <mat-icon *ngIf="currentFontSize === option.value">check</mat-icon>
                </button>
            </mat-menu>

            <!-- Settings button -->
            <button mat-button class="settings-button">
                <mat-icon>settings</mat-icon>
                <span>Navigation Settings</span>
            </button>
        </div>
    </div>
</div>
